import { useStatsigClient } from "@statsig/react-bindings";

export const useEnableWebChatBrandConfig = (): boolean => {
  const statsigClient = useStatsigClient();
  return statsigClient.checkGate("enable_web_chat_brand_config");
};
